<template>
  <router-view/>
</template>

<script>
import store from '@/store';
import detector from '@/utils/mobileDetector';
import { mapGetters } from 'vuex';

export default {
  name: 'Order',
  beforeRouteEnter(to, from, next) {
    store
      .dispatch('project/load', { order: to.params.order, theme: to.query.theme })
      .then(() => {
        store.dispatch('exteriors/toggleShowOverlayStatus', detector.mobile()
          ? !store.getters['project/statusSwitchMobileOff']
          : store.getters['project/statusSwitch']);

        return store.dispatch('project/loadTranslations', to.params.order);
      })
      .then(() => next());
  },
  computed: {
    ...mapGetters('service', ['primaryColor', 'fillOpacity', 'hoverfillOpacity']),
  },
  watch: {
    primaryColor(value) {
      this.setPrimaryColor(value);
    },
    fillOpacity(value) {
      this.setFillOpacity(value);
    },
    hoverfillOpacity(value) {
      this.setHoverFillOpacity(value);
    },
  },
  created() {
    this.setPrimaryColor(this.primaryColor);
    this.setFillOpacity(this.fillOpacity);
    this.setHoverFillOpacity(this.hoverfillOpacity);
  },
  methods: {
    setPrimaryColor(value) {
      if (value) {
        this.$vuetify.theme.themes.light.primary = value;
        this.$vuetify.theme.themes.light.accent = value;
        this.$root.$el.style.setProperty('--primary-color', value);
      }
    },
    setFillOpacity(value) {
      if (value) {
        this.$root.$el.style.setProperty('--fill-opacity', value);
      }
    },
    setHoverFillOpacity(value) {
      if (value) {
        this.$root.$el.style.setProperty('--hover-fill-opacity', value);
      }
    },
  },
  
};
</script>
